import React from "react";

function Header({ title, subheading, darkMode }) {
  return (
    <div
      className={
        darkMode ? "page-header dark wf-section" : "page-header wf-section"
      }
    >
      <h1 className={darkMode ? "h1-title light" : "h1-title"}>{title}</h1>
      <p className={darkMode ? "subheading-text light" : "subheading-text centre"}>
        {subheading}
      </p>
    </div>
  );
}

export default Header;
